<template>
  <div class="left_view">
    <div class="left">
      <div class="title">会员中心</div>
      <div class="sub_list">
        <span
          :class="isActiveRoute('/personcenter')?'sub_title2':'sub_title'"
          @click="goNav(0,'/personcenter')"
        >个人中心</span>
        <span :class="isActiveRoute('/userinfo')?'sub_title2':'sub_title'" @click="goNav(1,'/userinfo')">我的信息</span>
        <span
          :class="isActiveRoute('/scoreinfoview')?'sub_title2':'sub_title'"
          @click="goNav(2,'/scoreinfoview')"
        >积分明细</span>
      </div>
      <div style="height:40px;"></div>
      <div class="title">商城中心</div>
      <div class="sub_list">
        <span :class="isActiveRoute('/shopcart')?'sub_title2':'sub_title'"
          @click="goNav(3,'/shopcart')">购物车</span>
        <span
          :class="isActiveRoute('/addresslistview')?'sub_title2':'sub_title'"
          @click="goNav(4,'/addresslistview')"
        >收货地址</span>
        <span
          :class="isActiveRoute('/myorderlistview')?'sub_title2':'sub_title'"
          @click="goNav(5,'/myorderlistview')"
        >我的订单</span>
        <span
          :class="isActiveRoute('/consultationview')?'sub_title2':'sub_title'"
          @click="goNav(6,'/consultationview')"
        >需求咨询</span>
        <span
          :class="isActiveRoute('/evaluateorder')?'sub_title2':'sub_title'"
          @click="goNav(7,'/evaluateorder')"
        >评价晒单</span>
        <span
          :class="isActiveRoute('/servicelist')?'sub_title2':'sub_title'"
          @click="goNav(8,'/servicelist')"
        >售后服务</span>
      </div>
      <div style="height:40px;"></div>
      <div class="title">意见中心</div>
      <div class="sub_list">
        <span
          :class="isActiveRoute('/suggestionsview')?'sub_title2':'sub_title'"
          @click="goNav(9,'/suggestionsview')"
        >意见列表</span>
        <span
          :class="isActiveRoute('/addsuggestion')?'sub_title2':'sub_title'"
          @click="goNav(10,'/addsuggestion/0')"
        >投诉建议</span>
      </div>
      <div class="logout" @click="logout">退出登录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftView",
  data() {
    return {
      navList: [
        { index: 0, path: '/personcenter' },
        { index: 1, path: '/userinfo' },
        { index: 2, path: '/scoreinfoview' },
        { index: 3, path: '/shopcart' },
        { index: 4, path: '/addresslistview' },
        { index: 5, path: '/myorderlistview' },
        { index: 6, path: '/consultationview' },
        { index: 7, path: '/evaluateorder' },
        { index: 8, path: '/servicelist' },
        { index: 9, path: '/suggestionsview' },
        { index: 10, path: '/addsuggestion' }
      ],
      currentIndex: 0,
      isLogin: true
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    }
  },
  created() {
    // 在创建组件时根据当前路由设置活动菜单
    this.setActiveMenu();
  },
  watch: {
    // 监听路由变化，更新活动菜单
    '$route.path': {
      handler() {
        this.setActiveMenu();
      },
      immediate: true
    }
  },
  methods: {
    // 设置当前活动菜单
    setActiveMenu() {
      const currentPath = this.$route.path;
      const activeItem = this.navList.find(item => currentPath.includes(item.path));
      if (activeItem) {
        this.currentIndex = activeItem.index;
      }
    },
    // 检查路由是否匹配
    isActiveRoute(path) {
      return this.$route.path.includes(path);
    },
    // 导航到指定路径
    goNav(index, path) {
      this.currentIndex = index;
      if (this.$route.path !== path) {
        this.$router.push({ path: path }, () => {}, () => {});
      }
    },
    handleCommand(command) {
      switch (command) {
        case "1":
          this.$router.replace({ path: "/login1" });
          break;
        case "2":
          this.$router.replace({ path: "/login2" });
          break;
        case "3":
          this.$router.replace({ path: "/login3" });
          break;
      }
    },
    logout() {
      this.$store.commit('logout')
      this.$router.push('/register')
    }
  }
};
</script>
 <style lang="less" scoped>
.left_view {
  display: flex;
  flex-direction: row;
  margin-left: 12%;
  margin-top: 100px;
  margin-bottom: 10px;
}
.left {
  background: #ffffff;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.title {
  color: #222222;
  font-size: 16px;
  line-height: 23px;
  font-weight: 500; 
  width: 75px;
  font-weight: 400;
}
.sub_title {
  color: #666666;
  font-size: 14px;
  margin-top: 8px;
  cursor: pointer;
}
.sub_title2 {
  color: #3c9c8f;
  font-size: 14px;
  margin-top: 8px;
  cursor: pointer;
}
.sub_list {
  display: flex;
  flex-direction: column;
}
.logout{
  color: #c02f2f;
  font-size: 16px;
  margin-top: 30px;
  cursor: pointer;
}
</style> 
